import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  linkedSignal,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LayoutBase } from '../../base/layout.base';
import { Router } from '@angular/router';
import { isPlatformBrowser, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'smm-header',
  imports: [TranslateModule, NgOptimizedImage],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header extends LayoutBase {
  private _platformId = inject(PLATFORM_ID);
  private _router = inject(Router);

  activeSection = linkedSignal(() => this.navigationService.activeSection());

  ngOnInit() {
    if (isPlatformBrowser(this._platformId)) {
      this._initializeScrollSpy();
    }
  }

  private _initializeScrollSpy() {
    const options = {
      root: null,
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeSection.set(entry.target.id);
        }
      });
    }, options);

    const sections = document.querySelectorAll('section[id]');
    sections.forEach((section) => observer.observe(section));
  }

  toggleMenu() {
    this.menuService.toggle();
  }
  closeMenu() {
    this.menuService.close();
  }
}
